/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useSelector } from 'react-redux';

const mapState = ({ imgRoute }) => ({ imgRoute });

export const StaticImg = (props) => {
  const { imgRoute } = useSelector(mapState);
  const { src } = props;
  return <img {...props} src={`${imgRoute}${src}`} />;
};
